<template>
  <div>
    <div class="is-expanded extended-panel" v-if="!activeVenue || !mobileView">
      <p class="panel-title">What's Nearby</p>
      <div class="panel-subtitle">&nbsp;</div>
      <div class="categories places" v-if="poi">
        <ul>
          <li v-for="(value, property) in poi" v-if="value.venue.length > 0" class="uk-open">
            <a class="categories-title" @click="setActivePoi(value)">
              <img :src="value.listIcon" alt="">
              {{value.displayName}}
            </a>
            <div class="uk-accordion-content">
              <a v-for="venue in value.venue" @click="selectActiveVenue(venue)" v-bind:class="{'is-active': activeVenue && activeVenue.id === venue.id}">{{venue.name}}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import Places from "@/mixins/Places";
import Common from "@/mixins/Common";

export default {
  name: 'places',
  mixins: [Places, Common],
  data() {
    return {
    }
  },
  mounted() {
    this.poi = this.$store.getters.getPoi;
    this.checkMutations()
  },
  watch: {

  },
  created() {
  },
  methods: {

  }
}
</script>




// WEBPACK FOOTER //
// src/components/amenities/Places.vue